"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedRinkebyERC777 = void 0;
// List of the supported rinkeby ERC777 tokens
exports.supportedRinkebyERC777 = {
    // Faucet Token on rinkeby network. Easy to use on tests.
    '0x745861AeD1EEe363b4AaA5F1994Be40b1e05Ff90': {
        decimals: 18,
        name: 'Super fDAI Fake Token',
        symbol: 'fDAIx',
    },
};
